export enum NamesModal {
  presentation__finish = 'presentation_finish',
  presentation__start_stats = 'presentation__start_stats',
  presentation__start = 'presentation__start',
  presentation__segmentation = 'presentation__segmentation',
  profile__update_information = 'profile__update_information',
  profile__update_password = 'profile__update_password',
}
